export const FONT_LIST: string[] = [
  'Arial',
  'Arial Black',
  'Barlow',
  'Cabin',
  'Comic Sans MS',
  'Courier New',
  'Crimson Text',
  'DM Sans',
  'Fira Sans',
  'Georgia',
  'Impact',
  'Inconsolata',
  'Inter',
  'Josefin Sans',
  'Karla',
  'Lato',
  'Libre Baskerville',
  'Lucida Console',
  'Manrope',
  'Merriweather',
  'Monaco',
  'Montserrat',
  'Mukta',
  'Noto Sans',
  'Nunito',
  'Open Sans',
  'Oswald',
  'Outfit',
  'Palatino Linotype',
  'Playfair Display',
  'Plus Jakarta Sans',
  'Poppins',
  'PT Sans',
  'Quicksand',
  'Raleway',
  'Roboto',
  'Roboto Condensed',
  'Roboto Mono',
  'Rubik',
  'Segoe UI',
  'Source Code Pro',
  'Source Sans Pro',
  'Space Grotesk',
  'Tahoma',
  'Times New Roman',
  'Trebuchet MS',
  'Ubuntu',
  'Verdana',
  'Work Sans',
];
